/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateProjectDailyTaskCommand } from '../../models/update-project-daily-task-command';
import { UpdateProjectDailyTaskCommandResult } from '../../models/update-project-daily-task-command-result';

export interface ApiProjectDailyTasksUpdateProjectDailyTaskPatch$Params {
      body?: UpdateProjectDailyTaskCommand
}

export function apiProjectDailyTasksUpdateProjectDailyTaskPatch(http: HttpClient, rootUrl: string, params?: ApiProjectDailyTasksUpdateProjectDailyTaskPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectDailyTaskCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectDailyTasksUpdateProjectDailyTaskPatch.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateProjectDailyTaskCommandResult>;
    })
  );
}

apiProjectDailyTasksUpdateProjectDailyTaskPatch.PATH = '/api/ProjectDailyTasks/UpdateProjectDailyTask';
